import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import Swal from "sweetalert2";

const EditSafeModule = () => {
    const { id } = useParams();
    const [date, setDate] = useState('');
    const [images, setImages] = useState([]);
    const [fine, setFine] = useState('');
    const [cash, setCash] = useState('');
    const [error, setError] = useState('');
    const [existingImages, setExistingImages] = useState([]);
    const navigate = useNavigate();

    useEffect(() => {
        const fetchSafeModule = async () => {
            try {
                const response = await fetch(`https://pbhrm.com/api/safemodule/${id}`);
                const data = await response.json();

                if (data.status === 1) {
                    setDate(data.data.date);
                    setFine(data.data.fine);
                    setCash(data.data.cash);

                    try {
                        const parsedImages = typeof data.data.images === 'string'
                            ? JSON.parse(data.data.images)
                            : data.data.images;

                        setExistingImages(Array.isArray(parsedImages) ? parsedImages : []);
                    } catch (err) {
                        console.error('Error parsing existing images:', err);
                        setExistingImages([]);
                    }
                } else {
                    setError(data.message || 'Failed to fetch Safe Module');
                }
            } catch (error) {
                console.error('Error fetching Safe Module:', error);
                setError('An error occurred while fetching the Safe Module data.');
            }
        };

        fetchSafeModule();
    }, [id]);

    const handleSubmit = async (event) => {
        event.preventDefault();
        setError('');

        if (!date || !fine || !cash) {
            setError('Date, Fine, and Cash are required');
            return;
        }

        const formData = new FormData();
        formData.append('date', date);
        formData.append('fine', fine);
        formData.append('cash', cash);
        images.forEach((image) => formData.append('images', image));

        try {
            const response = await fetch(`https://pbhrm.com/api/safemodule/${id}`, {
                method: 'PUT',
                body: formData,
            });

            const contentType = response.headers.get('Content-Type');
            if (contentType && contentType.includes('application/json')) {
                const data = await response.json();
                if (data.status === 1) {
                     Swal.fire({
                       icon: "success",
                       title: data.message,
                     });
                    navigate('/SafeModuleList');
                } else {
                    setError(data.message);
                }
            } else {
                const errorText = await response.text();
                console.error('Error response:', errorText);
                setError('An unexpected error occurred');
            }
        } catch (error) {
            console.error('Error updating Safe Module:', error);
            setError(error.message || 'An error occurred while updating the Safe Module');
        }
    };

    const handleImageChange = (e) => {
        setImages([...e.target.files]);
    };

    return (
        <div id="main">
            <header className="mb-3">
                <a href="#" className="burger-btn d-block d-xl-none">
                    <i className="bi bi-justify fs-3"></i>
                </a>
            </header>

            <div className="page-heading">
                <div className="page-title">
                    <div className="row">
                        <div className="col-12 col-md-6 order-md-1 order-last">
                            <h3>Edit Safe Module</h3>
                        </div>
                    </div>
                </div>
            </div>

            <section className="section">
                <div className="row" id="basic-table">
                    <div className="col-12 col-md-12">
                        <div className="card">
                            <div className="card-header">
                                <h4>Edit Safe Module</h4>
                            </div>
                            <div className="card-body">
                                {error && <div className="alert alert-danger">{error}</div>}
                                <form onSubmit={handleSubmit}>
                                    <div className="mb-3">
                                        <label htmlFor="date" className="form-label">Date</label>
                                        <input
                                            type="date"
                                            id="date"
                                            className="form-control"
                                            value={date}
                                            onChange={(e) => setDate(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="fine" className="form-label">Fine</label>
                                        <input
                                            type="number"
                                            id="fine"
                                            className="form-control"
                                            value={fine}
                                            onChange={(e) => setFine(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="cash" className="form-label">Cash</label>
                                        <input
                                            type="number"
                                            id="cash"
                                            className="form-control"
                                            value={cash}
                                            onChange={(e) => setCash(e.target.value)}
                                            required
                                        />
                                    </div>

                                    <div className="mb-3">
                                        <label className="form-label">Current Images</label>
                                        <div className="d-flex flex-wrap gap-2">
                                            {existingImages.length > 0 ? (
                                                existingImages.map((img, idx) => (
                                                    <img
                                                        key={idx}
                                                        src={`https://pbhrm.com/${img}`}
                                                        alt={`Existing ${idx}`}
                                                        style={{ width: '100px', height: '100px', objectFit: 'cover', borderRadius: '5px' }}
                                                        onError={(e) => { e.target.src = 'https://via.placeholder.com/100x100?text=No+Image'; }}
                                                    />
                                                ))
                                            ) : (
                                                <p>No existing images</p>
                                            )}
                                        </div>
                                    </div>

                                    <div className="mb-3">
                                        <label htmlFor="images" className="form-label">Upload New Images</label>
                                        <input
                                            type="file"
                                            id="images"
                                            className="form-control"
                                            multiple
                                            onChange={handleImageChange}
                                        />
                                    </div>

                                    <div className="text-end">
                                        <button type="submit" className="btn btn-primary">
                                            Update Safe Module
                                        </button>
                                    </div>
                                </form>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </div>
    );
};

export default EditSafeModule;
